import { ReactNode } from "react";

import { BulkActionsVariant, BulkEntityActionItem } from "components/BulkActions/types";
import { FlowsProjectRoleBindingView } from "shared/Flows/Projects/useFlowsProject/types";

export enum FlowsProjectRolesBulkActions {
  Unassign = "Unassign",
}

export type FlowsProjectRolesBulkActionsAnalyticsPayload = {
  view: BulkActionsVariant;
  metadata: Record<string, string | boolean>;
};

export type FlowsProjectRolesMutationVariables = null;

export type FlowsProjectRolesBulkActionItem = BulkEntityActionItem<
  FlowsProjectRolesBulkActions,
  FlowsProjectRoleBindingView,
  FlowsProjectRolesMutationVariables
>;

export type FlowsProjectRolesBulkActionsConfirmActionStepProps = {
  bulkActionsVariant: BulkActionsVariant;
  onConfirm: (
    mutationVariables: FlowsProjectRolesMutationVariables,
    analyticsPayload: FlowsProjectRolesBulkActionsAnalyticsPayload
  ) => void;
  onCancel: () => void;
  action: FlowsProjectRolesBulkActionItem;
  customConfirmationMessage?: ReactNode;
};
